import { SupabaseSelectData } from '../interfaces';

export const DEFAULT_SUPABASE_QUERY: SupabaseSelectData = {
  sortColumn: 'fullName',
  sortAscending: true
}